<template>
  <div class="capusta-title">
    <div class="title-navigation" :class="{ 'outside': iconOutside }">
      <a
        class="title-navigation-link"
        :title="$t('common.back')"
        @click.prevent="goTo"
      ></a>
    </div>
    <div v-if="title" class="title-container">
      <h1>{{ title }}</h1>
      <slot />
    </div>
    <div class="description-container">
      <slot name="description" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    title: {
      type: String,
    },
    iconOutside: {
      type: Boolean,
      default() {
        return false;
      },
    },
    routeBack: {
      type: String,
      default() {
        return '';
      },
    },
  },
  computed: {
    ...mapGetters(['isDesktop']),
  },
  methods: {
    goTo() {
      if (this.$validate.isNotEmptyString(this.routeBack)) {
        this.$router.push({ name: this.routeBack });
        return;
      }

      if (this.isDesktop) {
        this.$router.push({ name: 'cabinet' });
        return;
      }

      this.$router.go(-1);
    },
  },
};
</script>

<style lang="sass" scoped>
  .capusta-title
    position: relative
    display: flex
    flex-direction: column
    font-size: 20px
    line-height: 24px
    color: #fff

  .title-navigation
    +respond-to('medium')
      position: absolute
      top: 0
      margin-right: 20px
      margin-bottom: 0

      &.outside
        margin-left: -80px

    + .title-content
      margin-top: 5px

      +respond-to('medium')
        margin-top: 0

  .title-navigation-link
    width: 20px
    height: 20px
    display: block
    border-radius: 50%
    background-color: transparent
    background-image: url('~@/assets/img/arrow-left.svg')
    background-repeat: no-repeat
    background-position: center
    background-size: cover
    transition: all .2s linear

    +respond-to('medium')
      width: 60px
      height: 60px
      display: inline-block
      vertical-align: middle
      background-size: auto

      #{theme('eclipse')} &
        background-color: #cbe2b3

        &:hover
          background-color: #7CB342

      #{theme('obsidian')} &
        background-color: #181722

        &:hover
          background-color: #7CB342

  .title-container
    width: 100%
    display: flex
    justify-content: space-between
    align-items: center

    +respond-to('medium')
      padding: 10px 0
      font-size: 20px
      line-height: 24px

    h1
      font-size: 20px
      line-height: 40px
      font-weight: 400

  .description-container
    font-weight: 500
    font-size: 16px
    line-height: 20px
    color: #fff
    opacity: .5

    span
      display: block

      +respond-to('medium')
        display: inline
</style>
